import React from 'react'
import CategoryList from '../components/CategoryList'
import BannerProduct from '../components/BannerProduct'
import HorizontalCardProduct from '../components/HorizontalCardProduct'
import VerticalCardProduct from '../components/VerticalCardProduct'

const Home = () => {
  return (
    <>
      <div>
        <CategoryList />
        <div className="grid grid-cols-12 mt-2 ml-2">
          <div className="hidden lg:block lg:col-span-2">
            <img
              src="https://res.cloudinary.com/dorip8bfj/image/upload/v1770114209/download_pn3lbf.jpg"
              alt="Sidebar"
              className="w-full h-full object-cover"
            />
          </div>


          <div className="col-span-12 lg:col-span-10">

            <BannerProduct />
          </div>
        </div>





        <HorizontalCardProduct category={"Alaskan Flies"} heading={"Top's Alaskan Flies"} />
        <HorizontalCardProduct category={"Dry Flies"} heading={"Popular's Dry Flies"} />

        <VerticalCardProduct category={"Barbless Flies"} heading={"Barbless Flies"} />
        <HorizontalCardProduct category={"Bass Flies"} heading={"Bass Flies"} />
        <HorizontalCardProduct category={"Blobs"} heading={"Blobs"} />
        <VerticalCardProduct category={"Beaded Nymphs"} heading={"Beaded Nymphs"} />
        <HorizontalCardProduct category={"Special Dries"} heading={"Special Dries"} />
        <HorizontalCardProduct category={"Boobies"} heading={"Boobies"} />
        <VerticalCardProduct category={"Streamers & Beaded Streamers"} heading={"Streamers & Beaded Streamers"} />
        <VerticalCardProduct category={"Buzzer Flies"} heading={"Buzzer Flies"} />
        <HorizontalCardProduct category={"Salmon Doubles"} heading={"Salmon Doubleses"} />
        <HorizontalCardProduct category={"Salmon Singles"} heading={"Salmon Singles"} />
        <VerticalCardProduct category={"Saltwaters"} heading={"Saltwaters"} />
        <HorizontalCardProduct category={"Pike"} heading={"Pike"} />
        <VerticalCardProduct category={"Czech Nymps and Gamarus"} heading={"Czech Nymps and Gamarus"} />
        <VerticalCardProduct category={"Conehead Streamers"} heading={"Conehead Streamers"} />






      </div>
    </>

  )
}

export default Home
